export const isMobileWidth=()=>window.innerWidth<=767